import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/partners/admin/useAdminPartnerQueryKeys.ts
var t = e("admin-partners", {
	list: (e) => e === void 0 ? ["list"] : ["list", e],
	detail: (e) => ["detail", e],
	stats: (e, t) => [
		"stats",
		e,
		t
	],
	applications: (e) => e === void 0 ? ["applications"] : ["applications", e],
	fraudFlags: () => ["fraud-flags"],
	timeseries: (e, t) => [
		"timeseries",
		e,
		t ?? null
	],
	conversions: (e) => ["conversions", e],
	linkQr: (e) => ["link-qr", e],
	linkTimeseries: (e, t, n) => [
		"link-timeseries",
		e,
		t,
		n ?? null
	],
	linkConversions: (e, t) => [
		"link-conversions",
		e,
		t
	]
});
//#endregion
export { t as adminPartnerQueryKeys };
